import type { XoLang } from "./xoDemoContext";
import { defaultLang, getXoLang as getXoLangFromSearch } from "./xoDemoContext";
import { type XoDemoCopy, xoDemoCopy } from "./xoDemoCopy";

export type { XoLang } from "./xoDemoContext";
export { defaultLang, getXoDemoMode, supportedLangs, xoDemoModeParams } from "./xoDemoContext";

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

/**
 * Deep-merge localized copy onto English defaults so `lang=nl` can ship partial maps
 * without leaving `undefined` holes in the UI.
 */
function mergeDemoCopy(base: XoDemoCopy, override: Partial<XoDemoCopy> | XoDemoCopy): XoDemoCopy {
  if (override === base) return base;
  const out: Record<string, unknown> = { ...base };
  for (const [key, raw] of Object.entries(override)) {
    const baseVal = (base as Record<string, unknown>)[key];
    if (raw === undefined) continue;
    if (Array.isArray(raw)) {
      out[key] = raw;
      continue;
    }
    if (isPlainObject(raw) && isPlainObject(baseVal)) {
      out[key] = mergeDemoCopy(baseVal as unknown as XoDemoCopy, raw as Partial<XoDemoCopy>);
      continue;
    }
    out[key] = raw;
  }
  return out as XoDemoCopy;
}

export function getXoLang(search: URLSearchParams | string | null | undefined): XoLang {
  return getXoLangFromSearch(search);
}

export function xoCopy(lang: XoLang): XoDemoCopy {
  const english = xoDemoCopy.en;
  if (lang === defaultLang) return english;
  return mergeDemoCopy(english, xoDemoCopy[lang]);
}
